import { UploadOutlined } from "@ant-design/icons";
import { Button, Upload, message } from "antd";
import { forwardRef } from "react";
import { uploadFile } from "../../util/API";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";

const UploadFile = (
  {
    handleUploadSuccess = () => {},
    handleRemoveFile = () => {},
    disabled = false,
    fileMimeType = [],
    fileTypeAllowNames = "",
    fileList = [],
    accept = "",
  },
  ref
) => {
  // #region    VARIABLES //////////////////////////
  //////////////////////////////////////////////////
  const { t } = useTranslation();
  const [isUploading, setIsUploading] = useState(false);
  //////////////////////////////////////////////////
  // #endregion VARIABLES //////////////////////////

  // #region    useEffect //////////////////////////
  //////////////////////////////////////////////////

  //////////////////////////////////////////////////
  // #endregion useEffect //////////////////////////

  // #region    FUNCTIONS //////////////////////////
  //////////////////////////////////////////////////
  function validation(file) {
    const validFileType = fileMimeType.includes(file.type);
    if (!validFileType) {
      message.error(
        `Bạn chỉ có thể upload file có định dạng ${fileTypeAllowNames}!`
      );
      return Upload.LIST_IGNORE;
    }
    return true;
  }

  function handleChange(info) {
    if (info.file.status === "uploading") {
      setIsUploading(true);
    }

    if (info.file.status === "removed") {
      handleRemoveFile(info.file.uid);
      return;
    }

    uploadFile(info.file.originFileObj).then((res) => {
      if (res.status === 200) {
        const resFile = {
          id: res.data?.[0]?.id,
          name: res.data?.[0]?.name,
          url: res.data?.[0]?.url,
        };

        let currentImagesLocal = localStorage.getItem("uploaded_images");
        if (!currentImagesLocal) {
          localStorage.setItem("uploaded_images", JSON.stringify([resFile]));
        } else {
          let tmp = JSON.parse(currentImagesLocal);
          tmp.push(resFile);

          localStorage.setItem("uploaded_images", JSON.stringify(tmp));
        }

        handleUploadSuccess(resFile);
      }

      setIsUploading(false);
    });
  }

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };
  //////////////////////////////////////////////////
  // #endregion FUNCTIONS //////////////////////////

  // #region    VIEWS //////////////////////////////
  //////////////////////////////////////////////////

  //////////////////////////////////////////////////
  // #endregion VIEWS //////////////////////////////
  return (
    <Upload
      listType="picture"
      customRequest={dummyRequest}
      beforeUpload={validation}
      onChange={handleChange}
      disabled={disabled}
      ref={ref}
      progress={{
        strokeColor: {
          "0%": "#108ee9",
          "100%": "#87d068",
        },
        strokeWidth: 3,
        format: (percent) => percent && `${parseFloat(percent.toFixed(2))}%`,
      }}
      fileList={fileList}
      accept={accept}
    >
      <Button icon={<UploadOutlined />}>
        {isUploading && <LoadingOutlined style={{ marginRight: "5px" }} />}
        {t("str_upload_file")}
      </Button>
    </Upload>
  );
};

export default forwardRef(UploadFile);
